<div class="column custom-form__block" :class="columnWidthClass">
    <b-field :label="field.label" :message="fieldMessage" :type="fieldType">
        <div class="is-flex is-h-100">
            <b-checkbox :name="field.name" :native-value="fieldValue" :modelValue="valueAsArray" @update:modelValue="onCheckboxInput(fieldValue, $event)" v-for="fieldValue of field.values">{{ fieldValue }}</b-checkbox>
        </div>
    </b-field>
</div>
